// Helper function to build tile preview URL
function buildTilePreview(urlTemplate, z, x, y) {
  if (!urlTemplate) return "";
  return urlTemplate.replace("{z}", String(z)).replace("{x}", String(x)).replace("{y}", String(y));
}
const APIKEY = "cb1_2p5r_1_44ee630c05162e79f896424d";
const ConstantsMap = {
  // Base CARTO map
  TILE_LAYER_CARTO: "https://cartodb-basemaps-a.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png?key=" + APIKEY,
  // Aerial imagery (ESRI World Imagery)
  TILE_LAYER_ORTHO: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",

  // Attribution for the maps
  ATTRIBUTION_CARTO: "© CARTO © OpenStreetMap contributors",
  ATTRIBUTION_ORTHO: "Source: Esri, Vantor, Earthstar Geographics, and the GIS User Community",

  // Default center and zoom for the maps
  DEFAULT_CENTER: [32.0853, 34.7818],
  DEFAULT_ZOOM: 12,
  MAX_ZOOM: 18,

  /** Leaflet pathOptions for terminal polygons — gray on map view, blue on aerial */
  TERMINAL_POLYGON_PATH_OPTIONS_CARTO: {
    fillColor: "#2E2E2E",
    fillOpacity: 0.55,
    color: "#2E2E2E",
    weight: 3,
  },
  TERMINAL_POLYGON_PATH_OPTIONS_ORTHO: {
    fillColor: "#2B308B",
    fillOpacity: 0.55,
    color: "#2B308B",
    weight: 3,
  },

  getTerminalPolygonPathOptions(mapType) {
    return mapType === "orthophoto"
      ? this.TERMINAL_POLYGON_PATH_OPTIONS_ORTHO
      : this.TERMINAL_POLYGON_PATH_OPTIONS_CARTO;
  },

  // Thumbnails built from existing map tile templates
  MAP_THUMB_URL: buildTilePreview("https://cartodb-basemaps-a.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png?key=" + APIKEY, 5, 18, 11),
  ORTHO_THUMB_URL: buildTilePreview("https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}", 8, 152, 104),
};

export default ConstantsMap;
